<template>
  <v-text-field
    v-on="computedListeners"
    v-bind="{ ...$attrs, ...$props }"
    type="text"
    :label="label"
    :placeholder="placeholder"
    :value="value"
    persistent-hint
  >
    <template #message="{message}">
      <italic-subheader :translation-path="message"> </italic-subheader>
    </template>
  </v-text-field>
</template>

<script>
import ItalicSubheader from '@/components/ItalicSubheader';

export default {
  name: 'DataInputFloat',
  components: {
    ItalicSubheader,
  },
  props: {
    label: {
      required: false,
      default: '',
    },
    placeholder: {
      required: false,
      default: '',
    },
    value: {
      required: true,
    },
    hint: {
      type: String,
      default: '',
    },
    allowNegative: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    computedListeners() {
      return {
        ...this.$listeners,
        blur: e => {
          this.checkNumber(e);
        },
        input: e => {
          this.setValue(e);
        },
        paste: e => {
          this.onPase(e);
          this.$emit('paste', e);
        },
        keydown: e => {
          this.checkValue(e);
          this.$emit('keydown', e);
        },
      };
    },
  },
  methods: {
    checkNumber(e) {
      const inputValue = e.target.value;
      if (inputValue.slice(-1) === '-') {
        e.target.value = inputValue + '1';
        this.$emit('input', parseInt(inputValue + '1'));
      }
      if (inputValue.slice(-1) === '.') {
        e.target.value = inputValue.slice(0, -1);
        this.$emit('input', parseInt(inputValue.slice(0, -1)));
      }
    },
    checkValue(e) {
      const { keyCode, key, metaKey, ctrlKey } = e;
      if ((ctrlKey || metaKey) && (keyCode === 86 || keyCode === 67 || keyCode === 65)) {
        return;
      }
      const inputValue = e.target.value.toString();
      const selectionStart = e.target.selectionStart;
      const selectionEnd = e.target.selectionEnd;
      const allowedKeyCodes = [8, 9, 37, 39];
      if (!inputValue.includes('.')) {
        if ((inputValue.includes('-') && selectionStart > 1) || (!inputValue.includes('-') && selectionStart > 0)) {
          allowedKeyCodes.push(190);
        }
      }
      if (this.allowNegative && selectionStart === 0 && (selectionEnd > 0 || !inputValue.includes('-'))) {
        allowedKeyCodes.push(173);
      }

      if (allowedKeyCodes.includes(keyCode)) {
        return;
      }
      if (!/[0-9]/.test(key)) {
        e.preventDefault();
        return;
      }
    },
    onPaste(e) {
      const selectionStart = e.target.selectionStart;
      const selectionEnd = e.target.selectionEnd;
      const oldValue = e.target.value;
      const pasteValue = e.clipboardData.getData('text');
      const sumValue = oldValue.substring(0, selectionStart) + pasteValue + oldValue.substring(selectionEnd);
      if (!/^-?\d+(?:[.]\d*?)?$/.test(sumValue)) {
        console.log('Wklejana wartość nie jest liczbą zmiennoprzecinkową');
        //TODO: Zmienić console.log na alert
        e.preventDefault();
        return;
      }
    },
    setValue(v) {
      if ((Number.parseFloat(v) || v == 0) && !(v === '-' || v.slice(-1) === '.')) {
        this.$emit('input', v || v == '0' ? Number.parseFloat(v) : null);
      } else if (v === '') {
        this.$emit('input', null);
      }
    },
  },
};
</script>
